import { useApi } from '@repo-level/core-front';
import { fetchConfig } from 'api/cms/config';
import { isNowBetween } from 'modules/common/helpers';
import type { FC } from 'react';
import { createContext, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { IConfigContext, IConfigContextData } from './helpers';

const initialValues: IConfigContextData = {
  quest: null,
  tournamentGames: [],
  isQuestDateValid: false,
};

export const ConfigContext = createContext<IConfigContext>(null as any);

export const ConfigContextProvider: FC = ({ children }) => {
  const [state, setState] = useState(initialValues);
  const [requestConfig, { data }] = useApi(fetchConfig);

  const {
    i18n: { language },
  } = useTranslation();

  useEffect(() => {
    requestConfig(language);
  }, [requestConfig, language]);

  useEffect(() => {
    if (data) {
      setState((prevState) => ({ ...prevState, ...data }));
    }
  }, [data]);

  const isQuestDateValid = useMemo(() => {
    if (state.quest === null) return false;
    return isNowBetween(state.quest.start, state.quest.end);
  }, [state.quest]);

  return (
    <ConfigContext.Provider value={{ ...state, isQuestDateValid }}>
      {children}
    </ConfigContext.Provider>
  );
};
